/* eslint-disable no-magic-numbers */
import React, { ReactNode } from 'react';
import Typography from 'carbon-react/lib/components/typography';
import Box, { BoxProps } from 'carbon-react/lib/components/box';

import { ListingPageHelpLink } from '../listing-page-help-link/listing-page-help-link';

interface ListingPageHeaderProps extends BoxProps {
  title: ReactNode;
  helpUrl?: string;
  variant?: 'header' | 'tab-header';
}

export const ListingPageHeader = ({ title, helpUrl, variant = 'header', ...boxProps }: ListingPageHeaderProps) => (
  <Box display="flex" gap="16px" alignItems="center" mt={variant === 'header' ? 0 : 4} mb={2} {...boxProps}>
    {variant === 'header' && (
      <Typography as="h1" fontSize="24px" fontWeight="700" my={0} lineHeight="30px">
        {title}
      </Typography>
    )}
    {variant === 'tab-header' && (
      <Typography as="h2" fontSize="20px" fontWeight="500" my={0} lineHeight="24px">
        {title}
      </Typography>
    )}
    {helpUrl && <ListingPageHelpLink url={helpUrl} />}
  </Box>
);
